(function () {
  var root = document.querySelector('.pp-landing');
  if (!root) return;
  var form = document.getElementById('pp-form');
  if (!form) return;

  var headerH1 = document.querySelector('h1.header__heading');
  if (headerH1) {
    var logoDiv = document.createElement('div');
    logoDiv.className = headerH1.className;
    while (headerH1.firstChild) logoDiv.appendChild(headerH1.firstChild);
    headerH1.parentNode.replaceChild(logoDiv, headerH1);
  }

  var idInput = document.getElementById('pp-variant-id');
  var ctaText = document.getElementById('pp-cta-text');
  var ctaBtn = document.getElementById('pp-cta');
  var barText = document.getElementById('pp-bar-text');
  var ctaWord = form.getAttribute('data-cta') || 'Comprar';

  function sync() {
    var sel = form.querySelector('input[name="pp_pack"]:checked');
    if (!sel) return;
    var label = sel.getAttribute('data-label');
    var price = sel.getAttribute('data-price');
    var available = sel.getAttribute('data-available') === 'true';
    idInput.value = sel.getAttribute('data-variant');
    var qty = document.getElementById('pp-qty');
    if (qty) qty.value = sel.getAttribute('data-qty') || '1';
    if (ctaText) ctaText.textContent = available ? ctaWord + ' ' + label + ' · ' + price : 'Agotado';
    if (ctaBtn) ctaBtn.disabled = !available;
    if (barText) barText.textContent = label + ' · ' + price;
  }

  Array.prototype.forEach.call(form.querySelectorAll('input[name="pp_pack"]'), function (r) {
    r.addEventListener('change', sync);
  });
  sync();

  var bar = document.getElementById('pp-bar');
  var buy = document.getElementById('pp-buy');
  if (bar && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('pp-bar-visible', visible);
    }).observe(buy);
  }
})();
